<script src="../../http/axios.js"></script>
<template>
  <div class="headbar" :style="{'background': themeColor}"
    :class="$store.state.app.collapse?'position-collapse-left':'position-left'">
    <!-- 导航收缩 -->
    <span class="hamburg">
      <el-menu class="el-menu-demo" :background-color="themeColor" text-color="#fff" :active-text-color="themeColor"
        mode="horizontal">
        <el-menu-item index="1" @click="onCollapse">
          <hamburger :isActive="collapse"></hamburger>
        </el-menu-item>
      </el-menu>
    </span>
    <!-- 导航菜单 -->
    <!--<span class="navbar">
      <el-menu :default-active="activeIndex" class="el-menu-demo" 
          :background-color="themeColor" text-color="#fff" active-text-color="#ffd04b" mode="horizontal" @select="selectNavBar()">
        <el-menu-item index="1" @click="$router.push('/')"><i class="fa fa-home fa-lg"></i>  </el-menu-item>
        <el-menu-item index="2" @click="openWindow('https://gitee.com/liuge1988/XYJ')">{{$t("common.projectRepo")}}</el-menu-item>
        <el-menu-item index="3" @click="openWindow('https://gitee.com/liuge1988/XYJ/wikis/Home')">{{$t("common.doc")}}</el-menu-item>
        <el-menu-item index="4" @click="openWindow('https://www.cnblogs.com/xifengxiaoma/')">{{$t("common.blog")}}</el-menu-item>
      </el-menu>
    </span>-->
    <!-- 下载进度条 -->
    <div style="float: left; color: #FFFFFF; width:70%; height: 60px; line-height: 30px; font-size: 14px; display:flex;"
      v-if="progressArray.length != 0">
      <div
        style="width: 240px; display: flex; flex-direction: column; text-align: left; background: rgba(255, 255, 255, 0.2); margin-right: 2px; position: relative;"
        v-for="(val,index) in progressArray" :key="index">
        <div style="width: 220px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; text-align: center;">
          {{ val.fileName == '' ? '加载中...': val.fileName }}</div>
        <div
          style="width: 240px; display: flex; justify-content: space-around; align-items: center; font-size: 12px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
          <el-progress :percentage="toDecimal(Number(val.loaded) / Number(val.total))" :ref="val.id" :id="val.id" :idx="index"
            :color="customColor" :stroke-width="14" style="width: 120px;" :text-inside="true">
          </el-progress>
          <span> {{ changeByteLimit(val.loaded) }}/{{ changeByteLimit(val.total) }}</span>
        </div>
        <!-- 删除图标 -->
        <div class="deleteIcon" @click="progressArray.splice(index, 1)">
          <i class="el-icon-close"></i>
        </div>
      </div>
    </div>
    <!-- 工具栏 -->
    <span class="toolbar">
      <el-menu class="el-menu-demo" :background-color="themeColor" :text-color="themeColor"
        :active-text-color="themeColor" mode="horizontal">
        <el-menu-item index="7">
          <!--跳转到百度翻译-->
          <el-button class="fa fa-adn" type="text" @click="openWindow('https://fanyi.baidu.com/?aldtype=16047#auto/zh')"
            style="color: #fff;font-size: 20px;">
          </el-button>
        </el-menu-item>
        <!--聊天-->
        <!-- <el-menu-item index="6" v-if="control == 1">
          <el-badge :value="value" class="item" :hidden="value == 0 || value < 0">
            <el-button class="fa fa-comments-o" type="text" @click="chat = !chat;$refs.vuechart.FriendList()"
              style="color: #fff;font-size: 20px;"></el-button>
          </el-badge>
        </el-menu-item> -->
        <el-menu-item index="1">
          <!--主题切换-->
          <theme-picker class="theme-picker" :default="themeColor" @onThemeChange="onThemeChange"></theme-picker>
        </el-menu-item>
        <!--语言切换-->
        <!-- <el-menu-item index="2" v-popover:popover-lang>
          <li style="color:#fff;" class="fa fa-language fa-lg"></li>
          <el-popover ref="popover-lang" placement="bottom-start" trigger="click" v-model="langVisible">
            <div class="lang-item" @click="changeLanguage('zh_cn')">简体中文</div>
            <div class="lang-item" @click="changeLanguage('en_us')">English</div>
          </el-popover>
        </el-menu-item> -->
        <!-- 我的私信 -->
        <!--<el-menu-item index="3" v-popover:popover-message>
          <el-badge :value="5" :max="99" class="badge" type="success">
            <li style="color:#fff;" class="fa fa-envelope-o fa-lg"></li>
          </el-badge>
          <el-popover ref="popover-message" placement="bottom-end" trigger="click">
            <message-panel></message-panel>
          </el-popover>
        </el-menu-item>-->
        <!-- 系统通知 -->
        <!--<el-menu-item index="4" v-popover:popover-notice>
          <el-badge :value="4" :max="99" class="badge" type="success">
            <li style="color:#fff;" class="fa fa-bell-o fa-lg"></li>
          </el-badge>
          <el-popover ref="popover-notice" placement="bottom-end" trigger="click">
            <notice-panel></notice-panel>
          </el-popover>
        </el-menu-item>-->
        <el-menu-item index="5" v-popover:popover-personal>
          <!-- 用户信息 -->
          <span class="user-info">
            <!-- <img :src="user.avatar" /> -->
            {{user.name}}
          </span>
          <el-popover ref="popover-personal" placement="bottom-end" trigger="click" :visible-arrow="false">
            <personal-panel :user="user"></personal-panel>
          </el-popover>
        </el-menu-item>
      </el-menu>
    </span>
    <!-- 汇率 -->
    <!-- 2023-10-07  操作费用、设定汇率只限邱总跟外销经理可以看-->
    <!-- 2024-11-13  操作费用、设定汇率只限邱总可以看-->
    <span class="toolbar" v-if="cusern != 'de01'">
      <span style="color: #fff;padding: 5.5px 0px;font-size: 14px;" :style="index != 0?'margin-left: 10px;':''" v-for="(item,index) in salesTarget" :key="index" v-if="item.value != '' && item.value != null">
        {{ item.title }}:<span style="font-weight: bold;">{{ item.value }}</span>
      </span>
      <span v-if="dayTitle != '' && dayTitle != null" style="color: #fff;padding: 5.5px 0px;font-size: 14px;font-weight: bold;">（{{ dayTitle }}）</span>
      <el-input style="margin-left: 5px;width: 180px;" v-model="fgzform.operatePrice" size="mini" v-if="deptName == '总经办'" :readonly="cusern != 'winwend'" @blur="saveExchangeRate">
        <template slot="prepend"><span :style="'color: '+themeColor+';'">操作费用</span></template>
      </el-input>
      <el-input style="margin-left: 5px;width: 180px;" v-model="fgzform.exchangeRate" size="mini" v-if="deptName == '总经办'" :readonly="cusern != 'winwend'" @blur="saveExchangeRate">
        <template slot="prepend"><span :style="'color: '+themeColor+';'">设定汇率</span></template>
      </el-input>
      <span style="color: #fff;padding: 5.5px 0px;font-size: 14px;" v-if="deptName == '总经办'">
        今日汇率:{{concRate.currentRate}}<i v-if="concRate.status != '0'" :class="concRate.status == '1'?'el-icon-top icon_top_cc':'el-icon-bottom icon_bottom_cc'"></i>  昨日汇率:{{concRate.frontRate}}({{concRate.contrastRate}})
      </span>
    </span>
   
    <div v-if="control == 1">
      <vue-chart v-show="chat" ref="vuechart" @updatebadge="isRead()" @isRead="isRead()"></vue-chart>
    </div>
    <el-dialog v-dialogDrag title="为了您的账号安全，请修改密码" width="30%" :visible.sync="dialogVisible" :close-on-click-modal="false" :append-to-body="true" :show-close="false">
      <el-form :model="passform" label-width="100px" :rules="passformRules" ref="passform" size="mini"
        label-position="right">
        <el-form-item label="ID" prop="id" v-if="false">
          <el-input v-model="passform.id" :disabled="true" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="初始密码" prop="password">
          <el-input v-model="passform.password" type="password" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPWD">
          <el-input v-model="passform.newPWD" type="password" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmpassword">
          <el-input v-model="passform.confirmpassword" type="password" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button size="mini" @click.native="dialogVisible = false">{{$t('action.cancel')}}</el-button> -->
        <el-button size="mini" type="primary" @click.native="submitForm" :loading="editLoading">{{$t('action.submit')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import mock from "@/mock/index";
import Hamburger from "@/components/Hamburger";
import ThemePicker from "@/components/ThemePicker";
import LangSelector from "@/components/LangSelector";
import Action from "@/components/Toolbar/Action";
import NoticePanel from "@/views/Core/NoticePanel";
import MessagePanel from "@/views/Core/MessagePanel";
import PersonalPanel from "@/views/Core/PersonalPanel";
import VueChart from "@/components/vueChart/index";
import axios from "@/http/axios";
export default {
  components: {
    Hamburger,
    ThemePicker,
    LangSelector,
    Action,
    NoticePanel,
    MessagePanel,
    PersonalPanel,
    VueChart,
  },
  data() {
    return {
      progressArray: [], // 进度条数组
      customColor: "#409EFF", // 自定义进度条颜色
      user: {
        name: "Louis",
        avatar: "",
        role: "超级管理员",
        registeInfo: "注册时间： " + sessionStorage.getItem("createTime"),
      },
      activeIndex: "1",
      langVisible: false,
      chat: false,
      value: 0,
      hidden: true,
      control: sessionStorage.getItem("chat_funciton"),
      concRate:'',//汇率参数
      salesTarget:[],// 销售目标
      dayTitle:'',
      fgzform:'',//外销利润点信息
      cusern:'',
      deptName:'',
      dialogVisible:false,//是否修改密码弹窗
      editLoading:false,
      passform:{
        name:sessionStorage.getItem('user'),
        password: '',
        newPWD: '',
        confirmpassword: ''
      },
      passformRules: {
        password: [
          { required: true, message: '请输入原始密码', trigger: 'blur' }
        ],
        newPWD: [
          { required: true, validator: this.notCheckpass, trigger: 'blur' }
        ],
        confirmpassword: [
          { required: true, validator: this.notCheckpass, trigger: 'blur' }
        ],
      },
    };
  },
  watch: {
    control(val) {
      this.control = val;
    },
    progressArray: {
      handler(newVal, oldVal) {
        newVal.forEach((ele, index) => {
          if (ele.loaded == ele.total && ele.total != 0) {
            this.progressArray.splice(index, 1);
          }
        });
      },
      deep: true,
    },
  },
  methods: {
    // 获取站内消息主题
    findMsgTopic() {
      this.axios({
        url: this.zuul + "/xyj-admin/r/sysInstationMsg/findMsgTopic",
        method: "post",
        params: {
        	branchId: sessionStorage.getItem("branchId"),
          userId: sessionStorage.getItem("userid")
        }
      }).then(res => {
        this.topiclist = res.data;
        res.data.forEach(item => {
          this.$mqtt.subscribe(this.$data._XYJ_CaseOnly_Id, item, {
            messageArrived: this.MessageArrivedMsg,
            messageDelivered: this.MessageDeliveredMsg
          });
        });
      }).catch(err => {
        this.$message.error(err.message);
      });
    },
    //2023-11-21 获取汇率更新通知
    MessageArrivedMsg: function(payloadMessage) {
      console.log('pay=================66',payloadMessage)
      const payloadString = JSON.parse(payloadMessage.payloadString);
      // this.payloadMessageObj = payloadString;
      // this.showNotify(payloadString);
      console.log('pay=================88',payloadString)
      if(payloadMessage.topic == '/instation/wwd/ExchangeRate'){
        this.concRate = payloadString
        sessionStorage.setItem('concRate',JSON.stringify(this.concRate))
      }
    },
    MessageDeliveredMsg: function(message) {
      console.log('payloadMessage=====22',message)
    },
    // 实时获取导出下载进度
    docProgress(axiosRun) {
      this.progressArray.push({
        id: this.$tu.createRandom(),
        loaded: 0,
        total: 0,
        fileName: "",
      });
      this.$nextTick(() => {
        let reponseAsk =
          this.$refs[this.progressArray[this.progressArray.length - 1].id];
        axiosRun(reponseAsk);
      });
    },
    // 功能：计算百分比 将浮点数四舍五入，取整数
    toDecimal(x) {
      var f = parseFloat(x);
      if (isNaN(f)) {
        return;
      }
      return Number((f * 100).toFixed(0));
    },
    // 功能 给颜色加透明度
    colorRgb(str, opacity) {
      let sColor = str.toLowerCase();
      if (sColor) {
        if (sColor.length === 4) {
          let sColorNew = "#";
          for (let i = 1; i < 4; i += 1) {
            sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
          }
          sColor = sColorNew;
        }
        //处理六位的颜色值
        let sColorChange = [];
        for (let i = 1; i < 7; i += 2) {
          sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
        }
        return "rgba(" + sColorChange.join(",") + "," + opacity + ")";
      } else {
        return sColor;
      }
    },
    // 功能 字节B转化成KB，MB，GB
    changeByteLimit(limit) {
      let size = "";
      if (limit < 0.1 * 1024) {
        //小于0.1KB，则转化成B
        size = limit.toFixed(2) + "B";
      } else if (limit < 0.1 * 1024 * 1024) {
        //小于0.1MB，则转化成KB
        size = (limit / 1024).toFixed(2) + "KB";
      } else if (limit < 0.1 * 1024 * 1024 * 1024) {
        //小于0.1GB，则转化成MB
        size = (limit / (1024 * 1024)).toFixed(2) + "MB";
      } else {
        //其他转化成GB
        size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";
      }

      let sizeStr = size + ""; //转成字符串
      let index = sizeStr.indexOf("."); //获取小数点处的索引
      let dou = sizeStr.substr(index + 1, 2); //获取小数点后两位的值
      if (dou == "00") {
        //判断后两位是否为00，如果是则删除00
        return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);
      }
      return size;
    },
    // 下载导出进度条
    format(percentage) {
      return percentage === 100 ? "" : `${percentage}%`;
    },
    // 打开新窗口
    openWindow(url) {
      window.open(url);
    },
    selectNavBar(key, keyPath) {
      console.log(key, keyPath);
    },
    // 折叠导航栏
    onCollapse: function () {
      this.$store.commit("onCollapse");
    },
    // 切换主题
    onThemeChange: function (themeColor) {
      this.$store.commit("setThemeColor", themeColor);
    },
    // 语言切换
    changeLanguage(lang) {
      lang === "" ? "zh_cn" : lang;
      localStorage.setItem('lang',lang);
      this.$i18n.locale = lang;
      this.langVisible = false;
    },
    open() {
      this.$refs.vuechart.open();
    },
    isRead() {
      this.$api.im
        .HistoryQuery({
          pageBean: {
            page: 1,
            pageSize: 1000,
          },
          querys: [
            {
              hasInitValue: true,
              operation: "EQUAL",
              property: "tochatid",
              relation: "AND",
              value: sessionStorage.getItem("chatid"),
            },
            {
              hasInitValue: true,
              operation: "EQUAL",
              property: "alreadyread",
              relation: "AND",
              value: 0,
            },
          ],
        })
        .then((res) => {
          if (res.data.rows.length > 0) {
            this.value = res.data.rows.length;
            this.hidden = false;
          } else {
            this.value = 0;
            this.hidden = true;
          }
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },
    getCurrentExchangeRate(){
      let data = {
            hostUrl: this.zuul,
            url:"/xyj-wwd-main/common/getCurrentExchangeRate",
            method: "get"
          };
      axios(data).then(res => {
        this.concRate = res.data
      }).catch(err => {
        console.error(err);
      })
    },
    getSalesTarget(){
      let data = {
            hostUrl: this.zuul,
            url:"/xyj-wwd-main/wwdSaleOrder/getSaleData",
            method: "get"
          };
      axios(data).then(res => {
        this.salesTarget = res.data;
      }).catch(err => {
        console.error(err);
      });
    },
    getAll() {
      let data = {
            hostUrl: this.zuul,
            url:"/xyj-wwd-main/wwdBasicsProfit/query",
            method: "post",
            data: {
              pageBean: {
                page: 1,
                pageSize: 1
              }
            }
          };
      axios(data).then(res => {
        this.fgzform = res.data.rows[0];
      }).catch(err => {
        console.error(err);
      })
    },
    //保存设置的汇率
    saveExchangeRate(){
      if(this.cusern != 'winwend'){
        return
      }
      let data = {
            hostUrl: this.zuul,
            url:"/xyj-wwd-main/wwdBasicsProfit/save",
            method: "post",
            data: this.fgzform
          };
      axios(data).then(res => {
        this.$message.success("设置成功");
      }).catch(err => {
        console.error(err);
      })
    },
    //密码正则判断
    notCheckpass(rule, value, callback) {
      if (value) {
        const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[a-zA-Z0-9]{8,16}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("密码必须包含数字和字母，且在8-16位之间"));
        }
      } else {
        callback();
      }
    },
    // 提交
    submitForm: function () {
				this.$refs.passform.validate((valid) => {
					if (valid) {
						this.$confirm('确认修改吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消'
            }).then(() => {
							this.editLoading = true
	            
	            if(this.passform.newPWD !== this.passform.confirmpassword){
	              this.$message({ message: '第二次输入的密码与第一次输入的不一致！', type: 'warning' })
	              this.editLoading = false
	              return;
	            }
	            let params = JSON.parse(JSON.stringify(this.passform));
              if(sessionStorage.getItem('branchCode')!='1'){
                let data ={
                  formerPassword: params.password,
                  newPassword: params.newPWD,
                  affirmPassword: params.confirmpassword,
                  userId:sessionStorage.getItem('userid')
                }
                this.axios({
                  url:this.zuul+'/xyj-admin/w/sysBranchUser/updatePassword',
                  method:'post',
                  params:data
                }).then(res => {
                  this.editLoading = false
                  if(res.code == 200) {
                    if(res.msg == '密码校验失败' || res.msg == '旧密码与新密码相同，无需修改' || res.msg == '账号不存在'){
                      this.$message({message: '操作失败, ' + res.msg, type: 'error'})                  
                      return;
                    }
                    this.$message({ message: '操作成功', type: 'success' })
                    this.dialogVisible = false;
                    this.$refs['passform'].resetFields()
                    sessionStorage.removeItem('jypsw');
                  } else {
                    this.$message({message: '操作失败, ' + res.msg, type: 'error'})
                    sessionStorage.removeItem('jypsw');
                  }
                }).catch(err => {
                  this.$message.error(err.message)
                  this.editLoading = false;
                  sessionStorage.removeItem('jypsw');
                });
              }else{
                delete params.confirmpassword;
                this.$api.common
                  .xyjGet({
                  url: "/user/updatePwd",
                  data: params
                })
                .then(res => {
                  this.editLoading = false
                  if(res.code == 200) {
                    if(res.msg == '密码校验失败' || res.msg == '旧密码与新密码相同，无需修改' || res.msg == '账号不存在'){
                      this.$message({message: '操作失败, ' + res.msg, type: 'error'})    
                      this.dialogVisible = false              
                      return;
                    }
                    this.$message({ message: '操作成功', type: 'success' })
                    this.dialogVisible = false
                    this.$refs['passform'].resetFields()
                    sessionStorage.removeItem('jypsw');
                  } else {
                    this.$message({message: '操作失败, ' + res.msg, type: 'error'})
                    sessionStorage.removeItem('jypsw');
                    this.dialogVisible = false
                  }
                });
              }
						})
					}
				})
			},
      getWeek (dateTime) {
				// 获取从1970年到现在的时间毫秒数
				var temp_ms = dateTime.getTime();
				let temptTime = new Date(temp_ms);
				// 今天周几，如果是周日，则设为7
				let weekday = temptTime.getDay() & 7;
				// 周1+5天=周六，得到本周6的日期,之所以以每周末的日期为基准，不能用每周日的日期为基准来计算
				// 当前日期的周六的日期
				temptTime.setDate(temptTime.getDate() - weekday + 1 + 5);
				// 每年的第一天，年/1/1，参数之中，0代表月份，介于0(1月) ~11(12月)之间的整数，getDay获取星期几同理
				// 第一天的日期
				let firstDay = new Date(temptTime.getFullYear(), 0, 1);
				let dayOfWeek = firstDay.getDay();
				let spendDay = 1;
				// 如果第一天不是星期日，那么就找到下一个星期日作为开始
				if (dayOfWeek != 0) {
				  spendDay = 7 - dayOfWeek + 1;
				}
				let yearOfW = temptTime.getFullYear();
				firstDay = new Date(yearOfW, 0, 1 + spendDay);
				/*
				1.Math.ceil 取大于等于所给值的最小整数
				2.86400000是换算到天的基数，js的时间差值为时间戳，即毫秒数
				  1000毫秒 * 60秒 * 60分钟* 24小时 = 86400000
				3.temptTime是当前日期，firstDay是当年第一天，周数计算公式就是（当前日期-第一天天数）/7 就是本年的第几周
				4.d是差距天数，res是周数
				*/
				let d = Math.ceil((temptTime.valueOf() - firstDay.valueOf()) / 86400000);
				let res = Math.ceil(d / 7) + 1;
				// let weekOfNow = firstDay.getFullYear().toString()+res.toString();
				return res.toString();
			},
      processX(xdata){ 
				if (xdata.length == 5){
					xdata = xdata.slice(0,4) + '0' + xdata.slice(4);
				}
				return xdata;
			},
  },
  mounted() {
    this.sysName = "xyj Platform";
    var user = sessionStorage.getItem("user");
    if (sessionStorage.getItem("userid") && sessionStorage.getItem("branchId")) {
      // 有的话证明登录进去了
      // 获取站内消息主题并订阅
      this.findMsgTopic();
    }
    if (user) {
      this.user.name = user;
      this.user.avatar = require("@/assets/my1.png");
    }
    sessionStorage.getItem("chat_funciton") == 1 && this.isRead();
    let usera = sessionStorage.getItem('user');
    this.cusern = usera.toLowerCase();
    this.deptName = sessionStorage.getItem('deptName');
    this.getAll();//获取外销利润点信息
    //2023-09-06 判断密码是否需要强制修改
    let jypsw = sessionStorage.getItem('jypsw');
    typeof(jypsw) == 'undefined'?'':jypsw;
    if(jypsw != '' && jypsw != null){
        this.dialogVisible = true;
      	this.editLoading = false;
    }
    // this.getCurrentExchangeRate()//2023-08-15 把定时去掉，刷新再触发 2023-11-22 改为由服务器传送汇率更新
    this.getSalesTarget();//2024-07-16 增加销售目标显示
    //避免由于刷新导致汇率信息丢失，在缓存重提取
    let concRate = sessionStorage.getItem('concRate')
    if(concRate != '' && concRate != null && concRate != 'undefined'){
      this.concRate = JSON.parse(concRate);
    }
    const currentDate = new Date();
    // 计算季度
    // const quarter = Math.floor((currentDate.getUTCMonth() + 3) / 3);
    // 计算月份
    // const month = currentDate.getMonth() + 1;
    // 计算周数
    var week = this.getWeek(currentDate);
    week = this.processX(week);
    this.dayTitle = '第'+week+'周';
  },
  computed: {
    ...mapState({
      themeColor: (state) => state.app.themeColor,
      collapse: (state) => state.app.collapse,
    }),
  },
};
</script>

<style scoped lang="scss">
.headbar {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1030;
  height: 60px;
  line-height: 60px;
  border-color: rgba(180, 190, 190, 0.8);
  border-left-width: 1px;
  border-left-style: solid;
}
.hamburg,
.navbar {
  float: left;
}
.toolbar {
  float: right;
}
.icon_top_cc{
 color: #93DD5B;
}
.icon_bottom_cc{
 color: #ff0000;
}
.lang-item {
  font-size: 16px;
  padding-left: 8px;
  padding-top: 8px;
  padding-bottom: 8px;
  cursor: pointer;
}
.lang-item:hover {
  font-size: 18px;
  background: #b0d6ce4d;
}
.user-info {
  font-size: 20px;
  color: #fff;
  cursor: pointer;
  img {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    margin: 10px 0px 10px 10px;
    float: right;
  }
}
.badge {
  line-height: 18px;
}
.position-left {
  left: 200px;
  border: none;
}
.position-collapse-left {
  left: 65px;
}
.item /deep/ .el-badge__content {
  top: 15px !important;
}
.deleteIcon {
  position: absolute;
  right: 5%;
  top: 5%;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  color: #fff;
}
.deleteIcon :hover {
  background: rgba(180, 190, 190, 0.8);
}
</style>



// WEBPACK FOOTER //
// src/views/HeadBar/HeadBar.vue